import { cn } from "@sylviq/ui-react-web/lib/cn";
import type { HTMLAttributes, ReactNode } from "react";

export interface PageHeaderProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  /** The page title, in the product's own plain language. */
  title: ReactNode;
  /** One sentence saying what this page is for. */
  description?: ReactNode;
  /** End-aligned actions: buttons, menus, a filter row. */
  actions?: ReactNode;
}

/** Title, one-line description, and an actions slot. */
export function PageHeader({
  title,
  description,
  actions,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-start justify-between gap-3",
        className,
      )}
      {...props}
    >
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description ? (
          <div className="mt-1 text-sm text-[var(--muted-foreground)]">
            {description}
          </div>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
